<template>
<p class="micad_text">
  {{paraText}}<br>
  <a href="" class="micad_text_link">{{paraTextInclude}}</a><br>
  <span class="micad_text_emphasis">{{paraTextInclude}}</span><br>
  <span class="micad_text_unavailable">{{paraTextInclude}}</span><br>
  <span class="micad_text_italic">{{paraTextInclude}}</span>
</p>
</template>

<script>
export default {
  name: 'Paragraphs',
  data() {
    return {
        paraText: "Quisque tristique quis leo vitae luctus. Etiam eget ullamcorper orci, quis iaculis libero. Morbi varius ante augue, eu luctus neque tristique non. Phasellus suscipit suscipit urna, eu lacinia odio ullamcorper sed. Donec euismod nec velit sit amet bibendum. Phasellus urna ligula, tempus lacinia est id, mattis faucibus turpis. Aliquam hendrerit id urna sodales ultricies. Aliquam vitae odio pulvinar, interdum turpis in, malesuada magna.",
        paraTextInclude: "Quisque tristique quis leo vitae luctus."
        }
    },
};
</script>
